export default __webpack_public_path__ + "static/media/ilustracion_tramites.a0efd9fc.svg";